export const experienceData = [
    {
        id: 1,
        company: 'Clabroom',
        jobtitle: 'Software Engineer Intern',
        startYear: 'July 2025',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Chegg Inc (Remote)',
        jobtitle: 'Subject Matter Expert (Data Analyst)',
        startYear: 'June 2024',
        endYear: 'Present'
    },
    {
        id: 3,
        company: 'Freelance',
        jobtitle: 'Freelancer ',
        startYear: 'June 2023',
        endYear: 'Present'
    },
    
]